import { render, staticRenderFns } from "./_MediaGroupMediaArchiveWrapper.vue?vue&type=template&id=515f2a2a&scoped=true&"
import script from "./_MediaGroupMediaArchiveWrapper.vue?vue&type=script&lang=js&"
export * from "./_MediaGroupMediaArchiveWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515f2a2a",
  null
  
)

export default component.exports